import { type KeyboardEvent } from 'react'

/**
 * True while an IME (e.g. Zhuyin) is composing. Keyboard shortcuts must ignore
 * these events. Safari / older Chromium report only keyCode 229 on the
 * keystroke that commits a candidate, so both checks are needed.
 */
export function isComposing(e: KeyboardEvent | globalThis.KeyboardEvent): boolean {
  const native = 'nativeEvent' in e ? e.nativeEvent : e
  // eslint-disable-next-line @typescript-eslint/no-deprecated -- 229 is the only signal on Safari
  return native.isComposing || native.keyCode === 229
}
